import { object } from "prop-types";
import React from "react";
import { clamp } from "lodash";

import DoubleCollections from "./DoubleCollections";
import SingleCollection from "./SingleCollection";
import ComponentContainer from "../../layouts/component-container";

import { componentProps, trim } from "../../utils/utils";

import "./multipurposeComponent.m.css";

const MultipurposeComponent = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { desktopBanner, hideSubHeadline, numberOfCollectionsToShow, firstColumnTheme, secondColumnTheme, adSlot } =
    componentProps(collection);

  let subCollections = [];

  if (numberOfCollectionsToShow > 0) {
    subCollections = collection.items
      .filter(({ type }) => type === "collection")
      .slice(0, clamp(numberOfCollectionsToShow, 2));
  }

  const theme = {
    0: trim(firstColumnTheme, "default"),
    1: trim(secondColumnTheme, "default"),
  };

  return (
    <ComponentContainer styleName="base" isBanner={true} isDesktopBanner={true} collection={collection} isTitle={false}>
      {subCollections.length > 0 ? (
        <div styleName="twoCollection">
          {subCollections.map((item, index) => (
            <DoubleCollections key={index} collection={item} theme={theme[index]} hideSubHeadline={hideSubHeadline} />
          ))}
        </div>
      ) : (
        <SingleCollection
          collection={collection}
          theme={trim(firstColumnTheme)}
          adSlot={adSlot}
          desktopBanner={desktopBanner}
          hideSubHeadline={hideSubHeadline}
        />
      )}
    </ComponentContainer>
  );
};

MultipurposeComponent.storyLimit = 5;
MultipurposeComponent.nestedCollectionLimit = [4, 4];

MultipurposeComponent.propTypes = {
  collection: object,
};

export default MultipurposeComponent;
